// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__iWf1A","header":"Tabs_header__vGKie","tab":"Tabs_tab__3Yjya","active":"Tabs_active__sGueS"};